import { useState, useEffect } from 'react';
import * as _ from 'lodash';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import SettingsFieldPageRow from '@IssueConsoleRepresentationalDisplay/SettingsFieldPageRow';
import DeleteFieldPageForm from '@IssueConsoleForms/DeleteFieldPageForm';
import LinearProgress from '@mui/material/LinearProgress';
import ProjectService from '@Helpers/URLHelpers/ProjectService';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import FieldService from '@Helpers/URLHelpers/FieldService';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import ErrorHandler from '@Root/ErrorHandler';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_ComStyles.scss';
import './FieldsPage.scss';

export default function FieldsPage(props) {

    const [pageLoader, setPageLoader] = useState(true);
    const [, setProject] = useState({});
    const [kaiziqResolveConnection, setKaiziqResolveConnection] = useState([]);
    const [, setFormTitle] = useState();
    const [, setFormDescription] = useState();
    const [, setImageUrl] = useState('');
    const [formFieldList, setFormFieldList] = useState([]);
    const [formFieldIdList, setFormFieldIdList] = useState([]);
    const [formFieldPageList, setFormFieldPageList] = useState([]);
    const [formFieldPageIdList, setFormFieldPageIdList] = useState([]);
    const [, setAdminFieldList] = useState([]);
    const [, setAdminFieldIdList] = useState([]);
    const [details, setDetails] = useState({});
    const [cursor, setCursor] = useState('auto');
    const [showDeleteFieldPageForm, setShowDeleteFieldPageForm] = useState(false);
    const [deleteFieldPageId, setDeleteFieldPageId] = useState(false);
    new ProjectService();
    const errorHandler = new ErrorHandler();
    const fieldService = new FieldService();
    const fieldPageService = new FieldPageService();
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    useReduxActiveUser();
    const { currentProject, currentProjectId } = useReduxProject();
    let fieldFilter = {
        projectIdList: [currentProjectId],
        tableType: 'kaiziqResolveConnection',
        tableId: props.kaiziqResolveConnection.id,
        filterAttribute1List: []
    };
    const className = 'resolve__fieldsPage';

    const safeParseJson = (value, fallback) => {
        if (value === undefined || value === null || value === '' || value === 'undefined') {
            return fallback;
        }
        if (typeof value === 'object') {
            return value;
        }
        try {
            return JSON.parse(value);
        } catch (err) {
            errorHandler.logError('FieldsPage safeParseJson', err);
            return fallback;
        }
    };

    const normalizeDetails = (detailsObj = {}) => {
        const fields = detailsObj?.fields || {};
        return {
            ...detailsObj,
            fields: {
                ...fields,
                form: Array.isArray(fields.form) ? fields.form : [],
                admin: Array.isArray(fields.admin) ? fields.admin : [],
                formPages: Array.isArray(fields.formPages) ? fields.formPages : []
            }
        };
    };

    useEffect(() => {
        if (!props?.kaiziqResolveConnection?.id) {
            return;
        }
        renderData();
    }, [props?.kaiziqResolveConnection?.id, currentProjectId])

    const renderData = async () => {
        setCursor('wait');
        setPageLoader(true);
        try {
            setProject(currentProject);
            let kaiziqResolveConnectionObj = await kaiziqResolveConnectionService.getKaiziqResolveConnectionById(props.kaiziqResolveConnection.id);
            kaiziqResolveConnectionObj = JSON.parse(kaiziqResolveConnectionObj.body);
            setKaiziqResolveConnection(kaiziqResolveConnectionObj);
            setFormTitle(kaiziqResolveConnectionObj.title);
            setFormDescription(kaiziqResolveConnectionObj.description);
            setImageUrl(kaiziqResolveConnectionObj.photo === undefined || kaiziqResolveConnectionObj.photo === null
                        ? ''
                        : URL.createObjectURL(dataURLtoFile(kaiziqResolveConnectionObj.photo)));

            let adminFilter = fieldFilter;
            adminFilter.filterAttribute1List = ['admin'];
            let filter = {
                fieldFilter: adminFilter
            }
            let adminFieldListObj = await fieldService.getListFiltered(filter);
            adminFieldListObj = safeParseJson(adminFieldListObj?.body, { result: [] });
            setAdminFieldList(adminFieldListObj?.result);
            let formFilter = fieldFilter;
            formFilter.filterAttribute1List = ['form'];
            filter = {
                fieldFilter: formFilter
            }
            let formFieldListObj = await fieldService.getListFiltered(filter);
            formFieldListObj = safeParseJson(formFieldListObj?.body, { result: [] });
            setFormFieldList(formFieldListObj?.result);
            let detailsObj = normalizeDetails(safeParseJson(kaiziqResolveConnectionObj?.details, {}));
            let formPagesIdListTemp = await renderFieldsPageListData(kaiziqResolveConnectionObj?.id, detailsObj);
            setFormFieldIdList(detailsObj.fields['form']);
            setAdminFieldIdList(detailsObj.fields['admin']);
            let tempFormPagesList = detailsObj.fields['formPages'];
            if(tempFormPagesList.length !== formPagesIdListTemp?.length) {
                detailsObj.fields['formPages'] = formPagesIdListTemp;
                kaiziqResolveConnectionObj.details = JSON.stringify(detailsObj);
                setKaiziqResolveConnection(kaiziqResolveConnectionObj);
            };
            setDetails(detailsObj);
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        setPageLoader(false);
    }

    const renderFieldsPageListData = async(kaiziqResolveConnectionId, detailsObj) => {
        var loadLoops = 0, loadingError = false, errorException, fieldIdList;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let fieldPageListObj = await fieldPageService.getFieldPageListByTable('kaiziqResolveConnection', kaiziqResolveConnectionId);
                fieldPageListObj = safeParseJson(fieldPageListObj?.body, []);
                const safeDetails = normalizeDetails(detailsObj);
                const formPages = _.cloneDeep(safeDetails?.fields?.formPages ?? []);
                const sortedFieldPageListObj = fieldPageListObj.sort((a, b) => {
                    return formPages.indexOf(a.id) - formPages.indexOf(b.id);
                });
                fieldIdList = sortedFieldPageListObj.map((fieldPage) => fieldPage.id);
                setFormFieldPageList(sortedFieldPageListObj);
                setFormFieldPageIdList(safeDetails.fields['formPages'])
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('Ticket Field Page List Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            return false;
        }
        return fieldIdList;
    }

    const toggleDeleteFieldPageForm = () => {
        setShowDeleteFieldPageForm(!showDeleteFieldPageForm);
    }

    const deleteFieldPage = async(index) => {
        setDeleteFieldPageId(formFieldPageIdList[index]);
        toggleDeleteFieldPageForm();
    }

    const dataURLtoFile = (dataurl) => {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], { type: mime });
    }

    const handleAddPageClick = async() => {
        setCursor('wait')
        try {
            let fieldPageObj = await fieldPageService.createFieldPageListByTable('kaiziqResolveConnection', kaiziqResolveConnection.id, currentProjectId);
            fieldPageObj = JSON.parse(fieldPageObj.body);
            let detailsObj = JSON.parse(kaiziqResolveConnection.details);
            let formPagesList = detailsObj.fields.formPages;
            formPagesList.push(fieldPageObj.id);
            detailsObj.fields.formPages = formPagesList;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            await renderData()
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto')
    }

    const shiftFieldPageUp = async(index) => {
        setCursor('wait');
        if(index > 0) {
            let fieldPageListIdObj = formFieldPageIdList;
            let tempPageId = fieldPageListIdObj[index - 1];
            fieldPageListIdObj[index - 1] = fieldPageListIdObj[index];
            fieldPageListIdObj[index] = tempPageId;
            let detailsObj = details;
            detailsObj.fields.formPages = fieldPageListIdObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            await renderData()
        }
        setCursor('auto');
    }

    const shiftFieldPageDown = async(index) => {
        let fieldPageListIdObj = formFieldPageIdList;
        if(index < fieldPageListIdObj.length - 1) {
            let tempField = fieldPageListIdObj[index + 1];
            fieldPageListIdObj[index + 1] = fieldPageListIdObj[index];
            fieldPageListIdObj[index] = tempField;
            let detailsObj = details;
            detailsObj.fields.formPages = fieldPageListIdObj;
            await kaiziqResolveConnectionService.updateKaiziqResolveConnectionDetails(kaiziqResolveConnection?.id, JSON.stringify(detailsObj));
            await renderData()
        }
    }

    return (
        <div className={className}
            style={{cursor: cursor}}>
            {
                pageLoader ?
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__loaders'}>
                            <LinearProgress className='thick-loader grey-text' color='inherit'/>
                            <LinearProgress className='thick-loader grey-text' color='inherit' />
                            <LinearProgress className='thick-loader grey-text' color='inherit' />
                        </div>
                    </div>
                :
                    <div className={className + '__inner'}>
                        <div className={className + '__inner__top flex-row-center-space-between'}>
                            <div className={className + '__inner__top__left semi-bold-text'}>
                                Total Pages: {formFieldPageIdList.length}
                            </div>
                            <div className={className + '__inner__top__right flex-row-center-1vw-gap'}>
                                <div className={className + '__inner__top__right__button'}>
                                    <BorderBlueButtonV2
                                        text='Add Page'
                                        disabled={kaiziqResolveConnection.connectionLive}
                                        onClick={handleAddPageClick}/>
                                </div>
                            </div>
                        </div>
                        <div className={className + '__inner__fields flex-column-center gap-1rem'}>
                            {
                                formFieldPageIdList?.map((fieldPageId, index) =>
                                    <SettingsFieldPageRow
                                        fieldPageId={fieldPageId}
                                        formFieldIdList={formFieldIdList}
                                        formFieldList={formFieldList}
                                        formFieldPageList={formFieldPageList}
                                        formFieldPageIdList={formFieldPageIdList}
                                        reloadFieldPageListData={renderFieldsPageListData}
                                        fieldPage={formFieldPageList.find((formFieldPage) => formFieldPage.id === fieldPageId)}
                                        index={index}
                                        setCursor={setCursor}
                                        shiftFieldPageUp={shiftFieldPageUp}
                                        shiftFieldPageDown={shiftFieldPageDown}
                                        handleDeleteFieldPageClick={deleteFieldPage}
                                        kaiziqResolveConnection={kaiziqResolveConnection}
                                        renderData={renderData}
                                        formDetails={details}
                                        cursor={cursor}
                                        type={'form'}/>
                                )
                            }
                        </div>
                    </div>
            }
            {
                showDeleteFieldPageForm &&
                    <DeleteFieldPageForm
                        open={showDeleteFieldPageForm}
                        closePopup={toggleDeleteFieldPageForm}
                        fieldPageId={deleteFieldPageId}
                        formFieldPageIdList={formFieldPageIdList}
                        kaiziqResolveConnection={props.kaiziqResolveConnection}
                        renderData={renderData}/>
            }
        </div>
    );
}

